<template>
    <main class="constra-survey-container" role="main">
        <!-- Header Section -->
        <header class="constra-header">
            <div class="constra-container">
                <img src="@/assets/img/constra/32543234_transparentO-4.png" 
                     alt="CONSTRA - AI-Powered Construction Project Monitoring and Drone Survey Software" 
                     style="max-width: 150px;"
                     loading="eager">
            </div>
        </header>

        <!-- Hero Section -->
        <section class="constra-hero" aria-labelledby="hero-heading">
            <h1 id="hero-heading">AI Based Project Operations Software</h1>
        </section>

        
        <!-- Drone Survey Section -->
        <section class="constra-feature-section" aria-labelledby="drone-survey-heading">
            <header class="constra-feature-text">
                <h2 id="drone-survey-heading">Constra Drone Based Survey</h2>
                <div class="constra-feature-sub-text">
                    <h3>AI Based Land Survey and Site Monitoring</h3>
                </div>
            </header>
            <div class="flex-align-center">
                <aside class="carousel-wrapper" aria-label="Drone survey and land monitoring features">
                    <ImageCarousel 
                        :images="constraCarouselData.constraDroneSurvey"
                        :autoplay="true"
                        />
                </aside>
                <div>
                    <div class="video-wrapper">
                        <iframe width="560" height="450" 
                                src="https://www.youtube.com/embed/bsd6kSgAfr4?si=ZmYnwwC8c9Hsf6oJ"
                                title="Constra Drone Survey - Advanced Land Surveying and Site Monitoring Demo"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" 
                                allowfullscreen
                                loading="lazy"
                                aria-label="Video demonstration of drone-based land surveying capabilities">
                        </iframe>
                    </div>
                </div>
            </div>
        </section>

        <!-- Constra Build Section -->
        <section class="constra-feature-section" aria-labelledby="constra-build-heading">
            <header class="constra-feature-text">
                <h2 id="constra-build-heading">Constra Build</h2>
                <div class="constra-feature-sub-text">
                    <h3> Time Machine with all Project visual information at one place</h3>
                </div>
            </header>
            <div class="flex-align-center flex-row-reverse">
                <aside class="carousel-wrapper" aria-label="Constra Build project monitoring features">
                    <ImageCarousel 
                        :images="constraCarouselData.constraBuild"
                        :autoplay="true"
                        />
                </aside>
                <div>
                    <div class="video-wrapper">
                        <iframe width="560" height="450" 
                                src="https://www.youtube.com/embed/CdNHUMHyOTA?si=FA6Vzz8IdmADbE3O"
                                title="Constra Build - AI Construction Progress Monitoring Demo Video"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" 
                                allowfullscreen
                                loading="lazy"
                                aria-label="Video demonstration of Constra Build AI construction monitoring features">
                        </iframe>
                    </div>
                </div>
            </div>
        </section>

        <!-- AI Features Section -->
        <section class="constra-feature-section" aria-labelledby="ai-features-heading">
            <header class="constra-feature-text">
                <h2 id="ai-features-heading">Experience the power of AI on Constra</h2>
                <div class="constra-feature-sub-text">
                    <h3>Automate work with touch of a button</h3>
                </div>
            </header>
            <div class="flex-align-center flex-row-reverse">
                <aside class="carousel-wrapper" aria-label="AI-powered construction automation features">
                    <ImageCarousel 
                        :images="constraCarouselData.constraAI"
                        :autoplay="true"
                        />
                </aside>
                <div>
                    <div class="video-wrapper">
                        <iframe width="560" height="450" 
                                src="https://www.youtube.com/embed/4xoYT7zzm_Y?si=BM67I0O6338JuHqQ"
                                title="AI-Powered Construction Automation - Smart Reporting and Site Safety Demo"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" 
                                allowfullscreen
                                loading="lazy"
                                aria-label="Video demonstration of AI-powered construction automation features">
                        </iframe>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import ImageCarousel from '../ImageCarousel.vue';
import { constraCarouselData } from '@/assets/db/static-data';

export default {
    components: {
        ImageCarousel
    },
    name: "ConstraSurveyComponent",
    data() {
        return {
            constraCarouselData
        }
    },
    methods: {
        scrollToHash() {
            if (this.$route.hash) {
                const targetId = this.$route.hash.substring(1); // Remove the '#' from hash in URL
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    setTimeout(() => {
                        const elementPosition = targetElement.getBoundingClientRect().top;
                        const offsetPosition = elementPosition + window.pageYOffset - 100; // we can adjust the hardcoded value as per scroll.

                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    }, 100); // Small delay to ensure DOM is ready
                }
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.scrollToHash();
        });
    },
    watch: {
        '$route'(to, from) {
            this.$nextTick(() => {
                this.scrollToHash();
            });
        }
    }
}
</script>

<style scoped>
.constra-survey-container {
    display: block;
    margin-top: 85px;
}

.constra-header {
    background-color: #036;
    padding: 20px 0;
    color: white;
    text-align: center;
}

.constra-hero {
    background-color: #036;
    color: #555;
    padding: 30px 20px;
    text-align: center;
}

.constra-hero h1 {
    font-size: 32px;
    color: white;
    line-height: 1.3;
}

.constra-feature-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 0;
    align-items: center;
    background-color: #ffffff;
}

.constra-feature-text {
    width: 100%;
    padding: 20px;
}


.constra-feature-text h2 {
    color: #036;
    font-size: 28px;
    margin-bottom: 10px;
}

.constra-feature-text h3 {
    color: #333;
    font-size: 20px;
    margin-bottom: 15px;
}

.carousel-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

iframe {
    border-radius: 8px;
}

.constra-feature-text {
    width: 100%;
    text-align: center;
}

.flex-align-center {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    gap: 10px;
    width: 75%;
}

.flex-row-reverse {
    flex-direction: row-reverse;
}

/* Responsive styles for mobile and medium screens */
@media (max-width: 1336px) {
    .flex-align-center {
        flex-direction: column;
        width: 90%;
    }
    
    .flex-row-reverse {
        flex-direction: column;
    }

    .constra-feature-text {
        width: 75%;
    }
    
    .constra-feature-text iframe {
        width: 100%;
        max-width: 400px;
        height: 225px;
    }

    .video-wrapper {
        margin-bottom: 20px;
    }
}

@media (max-width: 768px) {
    .constra-feature-text iframe {
        width: 100%;
        max-width: 320px;
        height: 180px;
    }
    
    .constra-feature-text h3 {
        font-size: 18px;
    }
    
    .constra-feature-text h2 {
        font-size: 24px;
    }

    .flex-align-center {
        gap: 20px;
    }

    .video-wrapper {
        margin-bottom: 20px;
    }
}

@media (max-width: 480px) {
    .constra-feature-text iframe {
        width: 100%;
        max-width: 280px;
        height: 157px;
    }
    
    .constra-feature-text {
        padding: 15px;
        width: 100%;
    }
    
    .constra-hero h1 {
        font-size: 24px;
    }

    .video-wrapper {
        margin-bottom: 15px;
    }
}
</style>